import { post } from './api';

export const contactUsAPI = {
  send(contactUsData) {
    return post('send.php', contactUsData);
  },
};
